import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from "../../services/common.service";
import { MatInput } from "@angular/material";
import { VernostServiceService } from "../../services/vernost-service.service";
import { DatePipe } from '@angular/common';
import { saveAs } from "file-saver";

@Component({
  selector: 'app-earn-refund-ftr',
  templateUrl: './earn-refund-ftr.component.html',
  styleUrls: ['./earn-refund-ftr.component.css']
})
export class EarnRefundFtrComponent implements OnInit {

  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;

  screentitle = "Refund FTR";
  search_details;
  disablebtn: boolean = true;
  IsErr: boolean = false;
  IsEmptyVal: boolean = true;
  newDate: any = new Date();
  journeydate: boolean = false;
  final;
  myDate: any = new Date();
  bookingdate: boolean = false;
  tomorrow1;
  noresult: any = "";
  search_detail_list: any = [];
  searchlist: boolean = true;
  loader: boolean = false;
  p: number = 1;
  totalItems: number = 1;


  constructor(private datePipe: DatePipe, private commonService: CommonService, private vernostService: VernostServiceService,) { }

  ngOnInit(): void {
    this.search_details = {
      jp_number: "",
      airline_pnr: "",
      booking_ref_no: "",
      ticket_no: "",
      refundDate_from: "",
      refundDate_to: "",
      incremented_to_date: "",
      journeyType: "Accrual"
    }
  }


  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }

  selectTypeOfJourney(journeyType) {
    this.search_details.journeyType = journeyType === 'A' ? "Accrual" : "Redeemption"
  }

  jpNumberValidation() {
    this.disablebtn = false;
    var JPNo = this.search_details.jp_number;
    let isJpNumberValid = this.commonService.validation('jpnumbervalidation', /^[A-Za-z0-9_]+$/, JPNo);
    this.IsErr = isJpNumberValid == true ? true : false;
  }

  isEmpty() {
    
    if (((this.search_details.refundDate_from != "" && this.search_details.refundDate_from != null) &&
      this.search_details.refundDate_to == "" || this.search_details.refundDate_to == null) || ((this.search_details.refundDate_from == "" || this.search_details.refundDate_from == null) &&
        this.search_details.refundDate_to != "" && this.search_details.refundDate_to != null)) {
      this.IsEmptyVal = true;
    }

    if (
      this.search_details.jp_number == "" &&
      this.search_details.airline_pnr == "" &&
      this.search_details.booking_ref_no == "" &&
      this.search_details.ticket_no == "" &&
      ((this.search_details.refundDate_from == "" || this.search_details.refundDate_from == null) ||
        (this.search_details.refundDate_to == "" || this.search_details.refundDate_to == null))
    ) {
      this.IsEmptyVal = true;
    } else {
      this.IsEmptyVal = false;
    }

    if(this.search_details.refundDate_from != "" && this.search_details.refundDate_to == "") {
      this.IsEmptyVal = true;
    }
  }

  pnrValidation() {
    this.disablebtn = false;
    let regex = /^[A-Za-z0-9_]+$/;
    this.search_details.airline_pnr = this.search_details.airline_pnr.toUpperCase();
    let JPNo = this.search_details.airlinepnr;

    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("pnrNO").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("pnrNO").style.color = "red";
      this.IsErr = true;
    } else {
      document.getElementById("pnrNO").innerHTML = "";
      this.IsErr = false;
    }
  }

  bookingRefValidation() {
    this.disablebtn = false;
    let bookingRefNo = this.search_details.order_id;
    let isBookingRefNoValid = this.commonService.validation('orderValidation', /^[A-Za-z0-9_]+$/, bookingRefNo);
    this.IsErr = isBookingRefNoValid == true ? true : false;
  }

  toggleDisable2() {
    this.journeydate = true;
    this.search_details.refundDate_to = "";
  }

  incresedate() {
    let tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    let tam = new Date(tomorrow);
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);
  }

  reset3() {
    this.input3.value = "";
    this.input4.value = ""
    this.search_details.refundDate_from = "";
    this.search_details.refundDate_to = "";
    this.tomorrow1 = "";
    this.isEmpty();
  }
  reset4() {
    this.input4.value = "";
    this.search_details.refundDate_to = "";
    this.isEmpty();
  }

  searchRefundReport() {
    this.loader = true;
    this.searchlist = true;
    this.noresult = "";
    this.search_details.refundDate_from = this.datePipe.transform(
      this.search_details.refundDate_from,
      "yyyy-MM-dd"
    );
    this.search_details.refundDate_to = this.datePipe.transform(
      this.search_details.refundDate_to,
      "yyyy-MM-dd"
    )
    
    this.vernostService.getRefundReportSearch(this.search_details).subscribe((response: any) => {
      this.loader = false;
      if(response.length) {
        this.totalItems = response.length;
        this.search_detail_list = response;
        this.searchlist = false;
      } else {
        this.search_detail_list = "";
        this.noresult = "Result Not Found";
      }
    })

  }

  downloadRefundReport() {
    this.loader = true;
    this.noresult = "";
    this.search_details.refundDate_from = this.datePipe.transform(
      this.search_details.refundDate_from,
      "yyyy-MM-dd"
    );
    this.search_details.refundDate_to = this.datePipe.transform(
      this.search_details.refundDate_to,
      "yyyy-MM-dd"
    )
    this.vernostService.getRefundReportDownload(this.search_details).subscribe((response) => {
      this.loader = false;
      if (response.size != 0) {
        this.search_details.journeyType === 'Accrual' ?
        saveAs(response, "Earn_Refund_Report.csv") : saveAs(response, "Redeem_Refund_Report.csv")
      } else {
        this.search_detail_list = ""
        this.noresult = "Result Not Found";
      }
    })
  }

  incrementDate(dateInput,increment) {
    var dateFormatTotime = new Date(dateInput);
    var increasedDate = new Date(dateFormatTotime.getTime() +(increment *86400000));
    return increasedDate;
  }

  pageCount(count) {
    this.p = count;
  }



}
